import React, { useRef } from "react";
import StickyHeadline from "./StickyHeadline";

const SplitScreenLayout = ({
  leftImage,
  rightContent,
  imageAlt = "Split screen image",
  className = "",
  navbarHeight = 0, // Height of navbar to account for sticky positioning
  headline = null, // Optional headline that will be sticky
  headlineClassName = "",
  id = null, // Optional ID for anchor navigation
}) => {
  const containerRef = useRef(null);
  const rightContentRef = useRef(null);
  const leftImageRef = useRef(null);

  return (
    <div ref={containerRef} className={`min-h-screen ${className}`} id={id}>
      {/* Sticky Headline - Full Width */}
      {headline && (
        <StickyHeadline
          headline={headline}
          navbarHeight={navbarHeight}
          className={headlineClassName}
        />
      )}

      {/* Desktop Layout - Two Separate Grids */}
      <div className="hidden lg:block lg:relative">
        {/* Left Grid - Image Only */}
        <div
          ref={leftImageRef}
          className="lg:grid lg:w-1/2 lg:sticky lg:z-10"
          style={{
            top: 0,
            // top: headline ? `${navbarHeight}px` : `${navbarHeight}px`, // Account for headline height
            height: headline ? `calc(100vh)` : `calc(100vh)`,
            backgroundImage: `url(${leftImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {/* Optional overlay for better text readability */}
          <div className="absolute inset-0 bg-black bg-opacity-10"></div>
        </div>

        {/* Right Grid - Content Only */}
        <div
          ref={rightContentRef}
          className="lg:grid lg:w-1/2 lg:ml-auto relative z-20"
          style={{
            marginTop: headline ? `calc(-100vh )` : `calc(-100vh)`, // Account for headline
          }}
        >
          <div className="min-h-screen bg-white">{rightContent}</div>
        </div>
      </div>

      {/* Mobile Layout - Better UX */}
      <div className="lg:hidden">
        {/* Mobile Image - Reduced height, not full screen */}
        <div className="w-full h-[60vh] relative">
          <img
            src={leftImage}
            alt={imageAlt}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black bg-opacity-10"></div>
        </div>

        {/* Mobile Content */}
        <div className="bg-white sm:px-24">{rightContent}</div>
      </div>
    </div>
  );
};

export default SplitScreenLayout;
